import config from "@/config"
import http from "@/utils/request"

export default {
    dfInvoice: {
        getPageList: {
            url: `${config.API_URL}/api/app/df-invoice/page-list`,
            name: "获取df发票分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getAsinPageList: {
            url: `${config.API_URL}/api/app/df-invoice/asin-page-list`,
            name: "根据ASIN来获取发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        exportAsin: {
            url: `${config.API_URL}/api/app/df-invoice/export-asin`,
            name: "根据ASIN导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    poInvoice: {
        getPageList: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/page-list`,
            name: "获取PO发票分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getCanCreatePageList: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/can-create-list`,
            name: "获取可以创建的PO分页发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getPoOrderDetail: {
            url: `${config.API_URL}/api/app/po-invoice/details`,
            name: "获取可以创建的PO分页发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        create: {
            url: `${config.API_URL}/api/app/po-invoice`,
            name: "创建PO发票",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/export-asin`,
            name: "根据ASIN导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpSalesDiscount: {
        getPageList: {
            url: `${config.API_URL}/api/app/co-op-sales-discount/page-list`,
            name: "获取销售折扣费用分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/co-op-sales-discount/export`,
            name: "导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpAccrual: {
        coOpAccrualCurrent: {
            getPageList: {
                url: `${config.API_URL}/api/app/co-op-accrual-current/page-list`,
                name: "获取销售折扣费用分页数据",
                get: async function (params) {
                    return await http.get(this.url, params);
                }
            },
            export: {
                url: `${config.API_URL}/api/app/co-op-accrual-current/export`,
                name: "导出发票数据",
                post: async function (params) {
                    return await http.post(this.url, params, {
                        responseType: 'blob'
                    });
                }
            }
        },
        coOpAccrualPrevious: {
            getPageList: {
                url: `${config.API_URL}/api/app/co-op-accrual-previous/page-list`,
                name: "获取往期应计修订",
                get: async function (params) {
                    return await http.get(this.url, params);
                }
            },
            export: {
                url: `${config.API_URL}/api/app/co-op-accrual-previous/export`,
                name: "导出发票数据",
                post: async function (params) {
                    return await http.post(this.url, params, {
                        responseType: 'blob'
                    });
                }
            }
        }
    }
}